//format
const wide = {
  xtra: ["", ""],
  fluid: ["", ""],
  wide: ["", ""],
  medium: ["col-2 d-none d-md-block", "col"],
  small: ["col-3 d-none d-md-block", "col"],
  mini: ["col-4 d-none d-md-block", "col"],
}

const wix = {xtra: [], fluid: [], wide: [], medium: [], small: [], mini: []}


export default function ContentFormat ({header, media, content, footer, name}) {

  // console.log (header, content, footer, name)

  return (
    <>
      {/* header */}
      <div className={`sticky-top ${header.show ? '' : 'd-none'}`}  style={{backgroundColor: '#FFF', height:'3rem'}}>
        
        <div className="" style={{ height:'3rem' }}>
          
          <div className={header.size === "xtra" ? '': header.size === "fluid" ? 'container-fluid' : 'container'}>
            <div className={header.size === "xtra" ? '' : "row"}>
              <div className={header.size === "xtra" ? '' : wide[header.size][0]}></div>
              <div className={header.size === "xtra" ? '' : wide[header.size][1]}>{header.data}</div>
              <div className={header.size === "xtra" ? '' : wide[header.size][0]}></div>
            </div>
          </div>

        </div>

      </div>


      {/* media */}
      <div className="">
      </div>


      {/* content */}
      <main>
      <div className={`${content.show ? '' : 'd-none'}`}
        style={{minHeight:'100vh', }}>
          
          <div className={content.size === "xtra" ? '': content.size === "fluid" ? 'container-fluid' : 'container'}>
            <div className={content.size === "xtra" ? '' : "row"}>
              <div className={content.size === "xtra" ? '' : wide[content.size][0]}></div>
              <div className={content.size === "xtra" ? '' : wide[content.size][1]}>{content.data}</div>
              <div className={content.size === "xtra" ? '' : wide[content.size][0]}></div>
            </div>
          </div>

        </div>
      </main>

      {/* footer */}
      <footer className={`${footer.show ? '' : 'd-none'}`} style={{backgroundColor:'#ECCFFF'}}>
        <div className=""></div>
      </footer>      

    </>
    )
  }